<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="姓名" prop="userRealName">
        <el-input
          v-model="queryParams.userRealName"
          placeholder="请输入姓名"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入手机号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="医生名称" prop="channelName">
        <el-input
            v-model="queryParams.channelName"
            clearable
            placeholder="请输入医生名称"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="预约日期" prop="day">
        <el-date-picker clearable
                        v-model="queryParams.appointDate"
                        placeholder="请选择日期"
                        type="date"
                        value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="预约状态" prop="status">
        <el-select v-model="queryParams.status" clearable placeholder="请选择状态" size="small">
          <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['biz:ChannelUser:edit']"
        >备注订单</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="single"
          @click="handleDelete"
          v-hasPermi="['biz:ChannelUser:remove']"
        >取消预约</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleHeXiao"
            v-hasPermi="['biz:ChannelUser:edit']"
        >核销</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['biz:ChannelUser:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange" :default-sort="defaultSort" @sort-change="handleSortChange">
      <el-table-column type="selection" width="55" align="center" />
<!--      <el-table-column label="主键" align="center" prop="id" />-->
      <el-table-column align="center" label="预约医生" prop="channelName" width="150" :show-overflow-tooltip="true"/>
      <el-table-column align="center" label="备注" prop="adminRemark" />
      <el-table-column label="企微姓名/预留姓名" align="center" prop="userRealName" />
      <el-table-column align="center" label="身份证号" prop="idNumber" width="120"/>
      <el-table-column align="center" label="手机号" prop="phone" width="120"/>
      <el-table-column align="center" label="预约时间" prop="appointDate" width="150" :show-overflow-tooltip="true" sortable="custom"  :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.appointDate, '{y}-{m}-{d}') }} {{scope.row.timeSegmentName}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column align="center" label="时间段" prop="timeSegmentName" width="120" />-->
<!--      <el-table-column align="center" label="渠道价格" prop="channelPrice" />-->

      <el-table-column align="center" label="状态" prop="status">
        <template slot-scope="scope">
        {{ getSelectNameByEnumsAndValue(statusList, scope.row.status) }}
        </template>
      </el-table-column>
<!--      <el-table-column label="核销码" align="center" prop="writeoffCode" />-->
<!--      <el-table-column align="center" label="核销时间" prop="writeoffDate" width="120">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.writeoffDate, '{y}-{m}-{d}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column align="center" label="核销人" prop="writeoffUserName" />-->
<!--      <el-table-column align="center" label="支付时间" prop="payDate" width="120" :show-overflow-tooltip="true" sortable="custom" :sort-orders="['descending', 'ascending']">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.payDate, '{y}-{m}-{d} {h}:{i}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column align="center" label="取消时间" prop="cancelDate" width="120">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.cancelDate, '{y}-{m}-{d} {h}:{i}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column align="center" label="创建时间" prop="createDate" width="120" sortable="custom" :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleLookDetail(scope.row)"
            v-hasPermi="['biz:ChannelUser:edit']"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改用户预约记录对话框 -->
    <el-dialog :title="titleHexiao" :visible.sync="openHexiao" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
                key="30"
                label="完成核销"
                value="30">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销员工" prop="writeoffUserId">
          <el-select v-model="form.writeoffEmployeeUserId" :style="{width: '100%'}"
                     filterable
                     remote
                     :remote-method="listEmployee"
                     placeholder="输入官方姓名搜索">
            <el-option v-for="(item, index) in employeeList" :key="index" :disabled="item.disabled"
                       :label="item.name" :value="item.userid"></el-option>
          </el-select>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormHexiao">确 定</el-button>
        <el-button @click="cancelHexiao">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改用户预约记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="备注" prop="adminRemark">
          <el-select v-model="form.adminRemark" placeholder="请选择">
            <el-option
                v-for="item in adminRemarkList"
                :key="item.value"
                :label="item.value"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>


    <!-- 添加或修改用户预约记录对话框 -->
    <el-dialog :title="titleDetail" :visible.sync="openDetail" append-to-body width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="渠道日id" prop="channelDayId">
          <el-input v-model="form.channelDayId" placeholder="请输入渠道日id" />
        </el-form-item>
        <el-form-item label="渠道名称" prop="channelName">
          <el-input v-model="form.channelName" placeholder="请输入渠道名称" />
        </el-form-item>
        <el-form-item label="渠道价格" prop="channelPrice">
          <el-input v-model="form.channelPrice" placeholder="请输入渠道价格" />
        </el-form-item>
        <el-form-item label="预约时间" prop="appointDate">
          <el-date-picker v-model="form.appointDate"
                          clearable
                          placeholder="请选择预约时间"
                          type="date"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="时间段" prop="timeSegmentName">
          <el-input v-model="form.timeSegmentName" placeholder="请输入时间段名称" />
        </el-form-item>
        <el-form-item label="用户id" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入用户id" />
        </el-form-item>
        <el-form-item label="姓名" prop="userRealName">
          <el-input v-model="form.userRealName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="身份证号" prop="idNumber">
          <el-input v-model="form.idNumber" placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单编号" prop="orderNumber">
          <el-input v-model="form.orderNumber" placeholder="请输入手机号" />
        </el-form-item>
        <!--        <el-form-item label="核销码" prop="writeoffCode">
                  <el-input v-model="form.writeoffCode" type="textarea" placeholder="请输入内容" />
                </el-form-item>-->
        <el-form-item label="核销时间" prop="writeoffDate">
          <el-date-picker v-model="form.writeoffDate"
                          clearable
                          placeholder="请选择核销时间"
                          type="date"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
<!--        <el-form-item label="核销人用户id" prop="writeoffUserId">
          <el-input v-model="form.writeoffUserId" placeholder="请输入核销人用户id" />
        </el-form-item>-->
        <el-form-item label="核销人用户名称" prop="writeoffUserName">
          <el-input v-model="form.writeoffUserName" placeholder="请输入核销人用户名称" />
        </el-form-item>

        <el-form-item label="支付时间" prop="payDate">
          <el-date-picker v-model="form.payDate"
                          clearable
                          placeholder="请选择支付时间"
                          type="date"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="取消时间" prop="cancelDate">
          <el-date-picker v-model="form.cancelDate"
                          clearable
                          placeholder="请选择取消时间"
                          type="date"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="form.createDate"
                          clearable
                          placeholder="请选择创建时间"
                          type="date"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
<!--        <el-form-item label="用户备注" prop="userRemark">
          <el-input v-model="form.userRemark" placeholder="请输入用户备注" />
        </el-form-item>-->
        <el-form-item label="管理员备注" prop="adminRemark">
          <el-input v-model="form.adminRemark" :autosize="{minRows: 10, maxRows: 10}" :style="{width: '100%'}"
                    placeholder="请输入管理员备注" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!--        <el-button type="primary" @click="submitForm">确 定</el-button>-->
        <el-button @click="cancelDetail">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addChannelUser,
  cancelChannelUser, editWriteOff,
  getChannelUser,
  listChannelUser,
  updateChannelUser
} from "@/api/biz/ChannelUser";
import {getEnumByClassFullName} from "@/api/biz/common";
import {listEmployee} from "@/api/wxCp/Employee";

export default {
  name: "ChannelUser",
  data() {
    return {
      statusList: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户预约记录表格数据
      userList: [],
      // userOfficerList: [],
      employeeList: [],
      adminRemarkList:[
          {"value":"术后1月"},
          {"value":"术后3月"},
          {"value":"术后6月"},
          {"value":"术后1年"},
          {"value":"1年以上"},
          {"value":"胆汁淤积复查"},
          {"value":"仅面诊不检查"}
      ],
      // 弹出层标题
      title: "",
      titleDetail: "",
      titleHexiao: "",

      // 是否显示弹出层
      open: false,
      openHexiao: false,
      openDetail: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        channelDayId: null,
        channelName: null,
        channelPrice: null,
        timeSegment: null,
        timeSegmentName: null,
        userId: null,
        userRealName: null,
        idNumber: null,
        phone: null,
        appointDate: null,
        status: null,
        orderNumber: null,
        writeoffCode: null,
        writeoffDate: null,
        writeoffUserId: null,
        writeoffEmployeeUserId: null,
        writeoffUserName: null,
        payDate: null,
        cancelDate: null,
        createDate: null,
        userRemark: null,
        adminRemark: null
      },
      // 默认排序
      defaultSort: {prop: 'createDate', order: 'descending'},
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getChannelOrderStatusEnum();
    this.getList();
    this.listEmployee();
  },
  methods: {

    // searchListUserOfficer(searchUserKey) {
    //   searchListUserOfficer({ "searchUserKey" : searchUserKey }).then(res => {
    //     this.userOfficerList = res.data;
    //   })
    // },
    listEmployee() {
      listEmployee({ "status" : 1 }).then(res => {
        this.employeeList = res.rows;
      })
    },
    getChannelOrderStatusEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.ChannelOrderStatusEnum").then(res => {
        this.statusList = res.data;
      })
    },
    /** 查询用户预约记录列表 */
    getList() {
      this.loading = true;
      listChannelUser(this.queryParams).then(response => {
        this.userList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    cancelDetail() {
      this.openDetail = false;
      this.reset();
    },
    // 取消按钮
    cancelHexiao() {
      this.openHexiao = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        channelDayId: null,
        channelName: null,
        channelPrice: null,
        timeSegment: null,
        timeSegmentName: null,
        userId: null,
        userRealName: null,
        idNumber: null,
        phone: null,
        appointDate: null,
        status: 0,
        writeoffCode: null,
        writeoffDate: null,
        writeoffUserId: null,
        writeoffUserName: null,
        payDate: null,
        cancelDate: null,
        createDate: null,
        userRemark: null,
        adminRemark: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order)
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    /** 查看操作 */
    handleLookDetail(row) {
      this.reset();
      const id = row.id || this.ids
      getChannelUser(id).then(response => {
        this.form = response.data;
        this.openDetail = true;
        this.titleDetail = "查看详情";
      });
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加用户预约记录";
    },
    handleHeXiao(row) {
      this.reset();
      const id = row.id || this.ids
      getChannelUser(id).then(response => {
        this.form = response.data;
        this.form.status = "30";
        this.openHexiao = true;
        this.titleHexiao = "核销预约订单";
      });

    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getChannelUser(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改用户预约记录";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateChannelUser(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addChannelUser(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 提交按钮 */
    submitFormHexiao() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            editWriteOff(this.form).then(response => {
              this.$modal.msgSuccess("订单已核销");
              this.openHexiao = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      if(ids.length > 1) {
        this.$modal.msgWarning("退款业务复杂重要，只能单条处理");
      }
      this.$modal.confirm('是否确认取消该订单？如有支付将原来返回').then(function() {
        return cancelChannelUser({id: ids[0]});
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("取消成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biz/channelUser/export', {
        ...this.queryParams
      }, `user_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
